import React, { useCallback, useRef, useState } from 'react'
import { FontIcon, tokens } from '@arvoreeducacao/bonsai-ds'
import { useTranslation } from 'i18n'
import { useUnreadCount } from '../hooks/use-unread-count'
import useA11yEnabled from 'utils/hooks/use-a11y-enabled'
import NotificationDropdown from './notification-dropdown'

const NotificationBell: React.FC = () => {
  const { t } = useTranslation()
  const { a11yEnabled } = useA11yEnabled()
  const [isOpen, setIsOpen] = useState(false)
  const { count } = useUnreadCount()
  const bellRef = useRef<HTMLButtonElement>(null)

  const handleBellClick = useCallback(() => {
    setIsOpen(prev => !prev)
  }, [])

  const closeDropdown = useCallback(() => {
    setIsOpen(false)
  }, [])

  return (
    <div className="relative flex items-center mr-1">
      <button
        ref={bellRef}
        onClick={handleBellClick}
        aria-label={
          count > 0 ? t('Notificações') + ` (${count})` : t('Notificações')
        }
        aria-expanded={isOpen}
        aria-haspopup="dialog"
        className="relative flex items-center justify-center border-none bg-transparent cursor-pointer p-2 rounded-full transition-colors hover:bg-[#F1F7FB] overflow-visible"
      >
        <FontIcon iconName="bell" size={20} color={tokens.colors.dark5} />
        {count > 0 && (
          <span
            className={`absolute top-[2px] right-[1px] w-4 h-4 rounded-full ${
              a11yEnabled
                ? 'bg-error-200 text-error-900'
                : 'bg-[#f95050] text-white'
            } text-[12px] font-bold flex items-center justify-center leading-none pointer-events-none z-1`}
          >
            {count > 99 ? '99+' : count}
          </span>
        )}
      </button>

      {isOpen && (
        <NotificationDropdown onClose={closeDropdown} bellRef={bellRef} />
      )}
    </div>
  )
}

export default NotificationBell
